import styled from '@emotion/styled';
import { theme } from '../../theme';

export enum LabelColor {
  INFORMATIVE = 'Informative',
  SUCCESS = 'Success',
  WARNING = 'Warning',
  DANGER = 'Danger',
  NEUTRAL = 'Neutral',
}

export enum LabelSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xlarge',
}

type LabelProps = {
  children: React.ReactNode;
  color: LabelColor;
  className?: string;
  subtle?: boolean;
  size?: LabelSize;
};

export const Label = ({ children, color, className, subtle, size }: LabelProps) => {
  return (
    <StyledDiv className={'label ' + className} color={color} subtle={subtle ?? true} data-cy="label" size={size}>
      {children}
    </StyledDiv>
  );
};

const StyledDiv = styled.span<{ color: LabelColor; subtle: boolean; size?: LabelSize }>`
  display: inline-block;
  gap: ${theme.spacing.c};
  border-radius: ${theme.spacing.c};
  font-size: ${({ size }) => {
    if (size === LabelSize.XSMALL) {
      return theme.typography.body.small.regular.fontSize;
    } else if (size === LabelSize.SMALL) {
      return theme.typography.body.small.regular.fontSize;
    } else if (size === LabelSize.MEDIUM) {
      return theme.typography.body.medium.regular.fontSize;
    } else if (size === LabelSize.LARGE) {
      return theme.typography.body.large.regular.fontSize;
    } else if (size === LabelSize.XLARGE) {
      return theme.typography.body.xLarge.regular.fontSize;
    } else {
      return theme.typography.body.small.regular.fontSize;
    }
  }};
  padding: ${({ size }) => {
    if (size === LabelSize.XSMALL) {
      return `0 ${theme.spacing.c}`;
    } else if (size === LabelSize.SMALL) {
      return `${theme.spacing.b} ${theme.spacing.d}`;
    } else if (size === LabelSize.MEDIUM) {
      return `${theme.spacing.c} ${theme.spacing.d}`;
    } else if (size === LabelSize.LARGE) {
      return `${theme.spacing.d} ${theme.spacing.e}`;
    } else if (size === LabelSize.XLARGE) {
      return `${theme.spacing.d} ${theme.spacing.f}`;
    } else {
      return `${theme.spacing.c} ${theme.spacing.d}`;
    }
  }};
  font-weight: ${({ size }) => {
    if (size === LabelSize.XSMALL) {
      return theme.typography.body.small.regular.fontWeight;
    } else {
      return theme.typography.body.small.regular.fontWeight;
    }
  }};
  color: ${({ color, subtle }) => (subtle ? theme.colors[`emotion${color}`].default : 'white')};
  background-color: ${({ color, subtle }) =>
    subtle ? theme.colors[`emotion${color}`].background : theme.colors[`emotion${color}`].default};
`;
